module.exports = __webpack_public_path__ + "static/media/Landing-BG.3e673cb1.jpg";